import type { ChangeAssessment } from '@/features/supplements/types';

export const matchesChangeAssessmentSnapshot = (
  rows: unknown,
  assessments: ChangeAssessment[] | undefined,
) => {
  if (!assessments || !Array.isArray(rows) || rows.length !== assessments.length) return false;

  const remaining = new Map(assessments.map((item) => [item.id, item]));
  return rows.every((row) => {
    if (!row || typeof row !== 'object') return false;
    const item = remaining.get(row.id);
    if (!item) return false;
    remaining.delete(row.id);

    return (
      item.status === row.status &&
      (item.updatedAt === row.updated_at ||
        (typeof item.updatedAt === 'string' &&
          typeof row.updated_at === 'string' &&
          Date.parse(item.updatedAt) === Date.parse(row.updated_at)))
    );
  });
};
